import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [institute, setInstitute] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data.user);
      setInstitute(data.institute || null);
      return data;
    } catch {
      setUser(null);
      setInstitute(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from Emergent OAuth callback, skip /me check.
    // AuthCallback will exchange the session_id and establish session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch (e) { console.error("logout failed", e); }
    setUser(null);
    setInstitute(null);
    // Force-fetch /auth/me right after — confirms cookies are really cleared. If a stale cookie
    // somehow survives, this will populate user back; better to surface the bug than hide it.
    try { await http.get("/auth/me"); } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, institute, loading, refresh, setUser, setInstitute, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
